module.exports = __webpack_public_path__ + "img/10.931ae135.jpg";